import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useEffect, useRef } from 'react';
import { useOccContext } from '../../../context/occ/hooks/use-occ-context';
import { Button } from '../../button/button';
import { Heading } from '../../heading/heading';
import { Image } from '../../image/image';
const b = bemClassBuilder('v-modal-header');
export const ModalHeader = observer(props => {
    const { accessibilityText, assets: occAssets } = useOccContext();
    const { heading, onClose, closeButtonIconName, showCloseButton = true, imageProps, header } = props;
    // For accessibility reasons. So that when the modal opens, the focus is inside the modal rather than outside it
    const closeButtonRef = useRef(null);
    useEffect(() => {
        var _a;
        (_a = closeButtonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, []);
    const headerContent = () => {
        if (header) {
            return header;
        }
        if (imageProps) {
            return _jsx(Image, Object.assign({}, imageProps, { className: b.element('image', undefined, imageProps.className) }));
        }
        return (_jsx(Heading, { level: "h2", className: b.element('title'), children: heading }));
    };
    return (_jsxs("header", { className: b.block({ showHeading: !!heading || !!header }, props.className), children: [headerContent(), showCloseButton && (_jsx(Button, { onClick: onClose, className: b.element('close-button'), label: accessibilityText.modalCloseButtonAriaLabel, iconName: closeButtonIconName || occAssets.modalCloseButtonIconName, iconOnly: true, ref: closeButtonRef }))] }));
});
ModalHeader.displayName = 'ModalHeader';
//# sourceMappingURL=header.js.map